import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reviewer-info__name" }
const _hoisted_2 = { class: "reviewer-info__age" }
const _hoisted_3 = { class: "reviewer-info__info" }

import { capitalize, computed } from 'vue';
import { formatDate } from '@/js/utils/dateTimeUtils';
import type { ReviewType } from '@/interfaces/review-types';

interface Props {
	review: ReviewType;
	size?: 'sm' | 'md';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewerInfo',
  props: {
    review: {},
    size: { default: 'md' }
  },
  setup(__props: any) {



const travelerName = computed((): string => {
	const { FirstName, Title } = __props.review;
	return `${Title} ${FirstName}`;
});

const blockClassModifier = computed((): string => (__props.size ? `reviewer-info--${__props.size}` : ''));

const travelDate = computed((): string => {
	const date = new Date();
	const { YearOfTravel, MonthOfTravel } = __props.review;
	date.setFullYear(YearOfTravel);
	date.setMonth(MonthOfTravel - 1);
	return formatDate(date, { year: 'numeric', month: 'long' });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['reviewer-info', blockClassModifier.value])
  }, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(travelerName.value), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode(" Alter: ")),
      _createElementVNode("span", null, _toDisplayString(_ctx.review.Age), 1 /* TEXT */)
    ]),
    _createElementVNode("p", _hoisted_3, "verreist als " + _toDisplayString(capitalize(_ctx.review.TravelledAs)) + " im " + _toDisplayString(travelDate.value), 1 /* TEXT */)
  ], 2 /* CLASS */))
}
}

})